import { LanguageProvider } from '@/lib/i18n';
import { Ziggy } from '@/lib/ziggy.js';
import { useCartStore } from '@/stores/cartStore';
import { CartItem } from '@/types';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Config } from 'ziggy-js';

if (typeof globalThis !== 'undefined') {
    window.Ziggy = Ziggy as Config;
}

window.updateReactCart = (cartItems: CartItem[]) => {
    useCartStore.getState().updateCartItems(cartItems);
};

(async () => {
    try {
        await createInertiaApp({
            resolve: (name) =>
                resolvePageComponent(
                    `./pages/${name}.tsx`,
                    import.meta.glob('./pages/**/*.tsx'),
                ),
            setup({ el, App, props }) {
                const root = createRoot(el);

                root.render(
                    <StrictMode>
                        <LanguageProvider>
                            <App {...props} />
                        </LanguageProvider>
                    </StrictMode>,
                );
            },
            defaults: {
                future: {
                    useDataInertiaHeadAttribute: true,
                },
            },
            progress: {
                color: '#4B5563',
            },
        });
    } catch (error) {
        console.error('Failed to create app:', error);
    }
})();
